import React, { useState } from "react";
import headShot from "../../assets/benPiper.jpg";



import BenHero from "./BenHero";
import BenNavbar from "./BenNavbar";
import BenServices from "./BenServices";
import BenAbout from "./BenAbout";
import BenAppointments from "./BenAppointments";
import BenFees from "./BenFees";
import BenReviews from "./BenReviews";
import BenContact from "./BenContact";
import BenExperience from "./BenExpirence";

export default function BenPiper() {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isAuthed, setIsAuthed] = useState(false);
  const [error, setError] = useState(false);

  const submitPassword = (e) => {
    e.preventDefault();
    if (password === "1984") {
      setIsAuthed(true);
      return;
    }
    setError(true);
  };

  if (!isAuthed) {
    return (
      <div className="profile-page">
        <section className="py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-4">
                <div className="p-4 bg-white rounded-4 border shadow-sm">
                  <h1 className="h5 brand-text-dark mb-3">Enter password</h1>

                  <form onSubmit={submitPassword}>
                    <div className="input-group mb-3">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoFocus
                      />
                      <button
                        type="button"
                        className="btn btn-outline-dark"
                        onClick={() => setShowPassword((x) => !x)}
                      >
                        {showPassword ? "Hide" : "Show"}
                      </button>
                    </div>

                    {error && (
                      <div className="text-danger small mb-3">
                        Incorrect password
                      </div>
                    )}

                    <button className="btn btn-dark w-100 rounded-pill">
                      View page
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="profile-page">
      <BenNavbar />
      <BenHero />

      {/* Intro */}
      <section id="intro" className="py-5">
  <div className="profile-container">

    <h1 className="brand-text-dark mb-0">Dr Benjamin Piper</h1>

    <p className="brand-text-light fw-bold">
      Counselling Psychologist and Clinical Director
    </p>

    <img
      src={headShot}
      alt="Benjamin Piper"
      className="img-fluid ben-profile-img mb-4"
    />

    <p className="profile-lead brand-text-gray mb-3">
      Benjamin is a qualified counsellor offering a calm, supportive
      space to explore challenges, emotions, and personal growth.
    </p>


    <div className="brand-text-gray">
      <p>
        Life can present painful experiences and ongoing challenges
        within relationships, work, health, or our sense of self that
        can feel overwhelming to navigate alone. Working with a
        psychologist can provide a supportive space to explore these
        difficulties, understand where they originate, and recognise
        the patterns that may be maintaining them.
      </p>

      <p className="mb-0">
        Avoiding or pushing away difficult thoughts and feelings can
        sometimes bring short term relief, but often leaves underlying
        issues unresolved. Therapy offers the opportunity to gently
        bring these experiences into awareness.
      </p>
    </div>

  </div>
</section>

      {/* About */}
<BenAbout />
<BenExperience />

{/* Services */}
<BenServices />

      {/* Appointments */}
<BenAppointments />
<BenFees />
<BenReviews />
<BenContact />

  
   
    </div>
  );
}
